var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIOs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 166,
    height: 94,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M85.995 18.22C89.94 13.025 95.42 13 95.42 13s.815 4.883-3.102 9.587c-4.183 5.023-8.937 4.2-8.937 4.2s-.893-3.95 2.614-8.57zm-2.112 11.99c2.03 0 5.794-2.787 10.694-2.787 8.436 0 11.754 5.998 11.754 5.998s-6.49 3.316-6.49 11.363c0 9.077 8.085 12.205 8.085 12.205s-5.652 15.897-13.286 15.897c-3.506 0-6.232-2.36-9.927-2.36-3.765 0-7.5 2.45-9.935 2.45C67.807 72.973 59 57.893 59 45.77c0-11.926 7.455-18.183 14.447-18.183 4.546 0 8.073 2.62 10.436 2.62z",
    fill: "#999",
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIOs);
export default __webpack_public_path__ + "static/media/iOS.afc6b1a4e18b6891e478ce8f1568daf2.svg";
export { ForwardRef as ReactComponent };